"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createControlsSDK = void 0;
const validations_1 = require("../../validations");
const validators_1 = require("./accessibilityUtils/validators");
const controlsSDKFactory = ({ setProps, props, create$w }) => ({
    get controls() {
        var _a;
        if (!((_a = props.ariaAttributes) === null || _a === void 0 ? void 0 : _a.controls)) {
            return undefined;
        }
        const $w = create$w();
        return $w(`#${props.ariaAttributes.controls}`);
    },
    set controls(selector) {
        if (!selector) {
            setProps({
                ariaAttributes: Object.assign(Object.assign({}, props.ariaAttributes), { controls: undefined }),
            });
            return;
        }
        setProps({
            ariaAttributes: Object.assign(Object.assign({}, props.ariaAttributes), { controls: selector.uniqueId }),
        });
    },
});
const customRules = {
    controls: [validators_1.createElementValidator('controls')],
};
exports.createControlsSDK = validations_1.withValidation(controlsSDKFactory, {
    type: ['object'],
    properties: {
        controls: {
            type: ['object', 'nil'],
        },
    },
}, customRules);
//# sourceMappingURL=controlsSDKFactory.js.map